import React, { useRef } from 'react';
import BackendTable from 'react-backend-table';
import { KTSVG } from '../../_metronic/helpers';
import { Tab, Tabs } from 'react-bootstrap-v5';
import { GetPagePermission } from '../components/UserPagePermission';
import userPermissionContext from '../../context/userPermissionContext';
import { useContext } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function PermissionList() {
	const backendTableRef = useRef(null);
	const backendTableRefProjects = useRef(null);
	const { jwt } = useContext(userPermissionContext);
	const hasPermission = GetPagePermission('/accessControl-permissionList');

	const columns = [
		{
			title: 'User ID',
			field: 'idUsers',
			sortable: true,
			searchable: true,
			thStyle: { textAlign: 'center' },
			tdStyle: { textAlign: 'center' },
		},
		{
			title: 'User Name',
			field: 'userName',
			sortable: true,
			searchable: true,
		},
		{
			title: 'Email',
			field: 'email',
			sortable: true,
			searchable: true,
		},
		{
			title: 'Role',
			field: 'roleName',
			sortable: true,
			searchable: true,
		}
	];

	const options = {
		url: process.env.REACT_APP_API_URL + 'getAllUsersWithRoles',
		authorization: 'Bearer ' + jwt.token,
		perPage: [10, 25, 50, 100],
		orderBy: 'users.id_users',
		orderType: 'desc',
		columnSearch: true,
	};

    const columnsProjects = [
        {
            title: 'User ID',
            field: 'idUsers',
            sortable: true,
            searchable: true,
            thStyle: { textAlign: 'center' },
			tdStyle: { textAlign: 'center' }
        },
        {
            title: 'User Name',
            field: 'userName',
            sortable: true,
            searchable: true,
        },
        {
            title: 'Email',
            field: 'email',
            sortable: true,
            searchable: true,
        },
        {
            title: 'Project',
            field: 'projectName',
            sortable: true,
            searchable: true,
        }
    ];

    const optionsProjects = {
        url: process.env.REACT_APP_API_URL + 'getAllUsersWithProjects',
        authorization: 'Bearer ' + jwt.token,
        perPage: [10, 25, 50, 100],
        orderBy: 'users.id_users',
        orderType: 'desc',
        columnSearch: true,
    };

	return (
		<>
			{hasPermission === 1 && (
				<div className="card card-custom">
					<div className="card-header d-flex flex-direction-row justify-content-between py-4">
						<div className="card-title w-50">
							<span>
								<KTSVG
									path="/media/icons/duotune/communication/com010.svg"
									className="svg-icon-1 svg-icon-primary"
								/>
							</span>
							<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
								PERMISSION LIST
							</span>
						</div>
					</div>
					<div className="ml-12">
						<div className="card-body">
							<Tabs defaultActiveKey="roles" id="permission-list-tabs" className="mb-3" mountOnEnter>
								<Tab eventKey="roles" title="Roles">
									<BackendTable ref={backendTableRef} columns={columns} options={options} />
								</Tab>
								<Tab eventKey="projects" title="Projects">
									<BackendTable ref={backendTableRefProjects} columns={columnsProjects} options={optionsProjects} />
								</Tab>
							</Tabs>
						</div>
					</div>
				</div>
			)}
			{hasPermission === 0 && (
				<div className="card card-custom" style={{ padding: '15px' }}>
					<SkeletonTheme>
						<p>
							<Skeleton containerClassName="avatar-skeleton" count={40} />
						</p>
					</SkeletonTheme>
				</div>
			)}
		</>
	);
}

export default PermissionList;
